import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { MapGoogle } from '../../component';
import { ExternalService } from '../../service';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';

const mapBoxStyle = {
    position: 'relative',
    width: 'inherit',
    height: 'inherit',
    margin: '0px auto 0 auto',
    display: { xs: 'block', sm: 'block', md: 'block' }
};

const mapBoxContentStyle = {
    position: 'absolute',
    top: '12px',
    left: '12px',
    zIndex: '1000'
};

const MapOptions = ({ onResetClick, onSubmitClick }) => {
    const [expandedOptions, setExpandedOptions] = useState(true);

    const [countryData, setCountryData] = useState();
    const [selectedCountry, setSelectedCountry] = useState('All');

    const [cityData, setCityData] = useState();
    const [selectedCity, setSelectedCity] = useState('All');

    useEffect(() => {
        (async () => {
            await getCountry();
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (selectedCountry && selectedCountry !== 'All') {
                await getCity();
            }
        })();
    }, [selectedCountry]);

    const getCity = async () => {
        const data = await ExternalService.getAllCityByCountry(selectedCountry);

        if (!data || data.length <= 0) {
            console.error('Error: Getting Cities.');
            return;
        }

        const tempData = data.map((item) => {
            return {
                label: item,
                value: item
            };
        });

        setCityData(tempData);

        if (tempData.length === 1) {
            setSelectedCity(tempData[0].value);
        } else {
            setSelectedCity('All');
        }
    };

    const getCountry = async () => {
        const data = await ExternalService.getAllCountry();

        if (!data) {
            console.error('Error: Getting Countries.');
            return;
        }

        const tempData = data.map((item) => {
            return {
                label: item,
                value: item
            };
        });

        setCountryData(tempData);
    };

    const handleChangeCountry = (event) => {
        setSelectedCountry(event.target.value);
    };

    const handleChangeCity = (event) => {
        setSelectedCity(event.target.value);
    };

    const handleResetClick = () => {
        setSelectedCountry('All');
        setSelectedCity('All');
        onResetClick();
    };

    const handleSubmitClick = () => {
        onSubmitClick(selectedCountry, selectedCity);
    };

    return (
        <>
            <Box sx={{ boxShadow: 3, padding: 0, backgroundColor: 'rgb(241, 241, 242)', width: '30%', minWidth: '300px' }}>
                <Accordion expanded={expandedOptions} onChange={() => setExpandedOptions(!expandedOptions)}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: 'rgb(255, 255, 255)' }} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{ backgroundColor: 'rgb(0, 42, 78)', color: 'rgb(255, 255, 255)' }}
                    >
                        <Stack direction={'row'} spacing={1}>
                            <SearchIcon />
                            <strong>Search Options </strong>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack direction={'column'} spacing={2}>
                            <FormControl fullWidth>
                                <InputLabel id="lblCountry">Country</InputLabel>
                                <Select labelId="lblCountry" id="ddlCountry" value={selectedCountry} label="Country" onChange={handleChangeCountry}>
                                    <MenuItem value={'All'}>All</MenuItem>
                                    {countryData &&
                                        countryData.map((item) => {
                                            return <MenuItem value={item.value}>{item.label}</MenuItem>;
                                        })}
                                </Select>
                            </FormControl>

                            {selectedCountry && selectedCountry !== 'All' && cityData && (
                                <FormControl fullwidth>
                                    <InputLabel id="lblCity">City</InputLabel>
                                    <Select labelId="lblCity" id="ddlCity" value={selectedCity} label="City" onChange={handleChangeCity}>
                                        <MenuItem value={'All'}>All</MenuItem>
                                        {cityData &&
                                            cityData.map((item) => {
                                                return <MenuItem value={item.value}>{item.label}</MenuItem>;
                                            })}
                                    </Select>
                                </FormControl>
                            )}

                            <Divider sx={{ border: '1px solid #da1f33' }} orientation="horizontal" flexItem />

                            <Stack direction={'row'} spacing={0.5}>
                                <Button variant="outlined" size="medium" fullWidth onClick={handleResetClick}>
                                    Reset
                                </Button>
                                <Button variant="contained" size="medium" fullWidth onClick={handleSubmitClick}>
                                    Submit
                                </Button>
                            </Stack>
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>
    );
};

const Map = () => {
    const [offices, setOffices] = useState([]);
    const [resetMap, setResetMap] = useState(true);

    const [selectedCountry, setSelectedCountry] = useState();
    const [selectedCity, setSelectedCity] = useState();

    useEffect(() => {
        (async () => {
            await getOffices();
        })();
    }, [selectedCountry, selectedCity]);

    const getOffices = async () => {
        const data = await ExternalService.getOfficesByCountryCity(selectedCountry, selectedCity);

        if (!data) {
            console.error('Error: Getting Offices.');
            return;
        }

        setOffices(data);
    };

    const handleResetMap = () => {
        setSelectedCountry();
        setSelectedCity();

        setResetMap(!resetMap);
    };

    const handleOptionsSubmit = (country, city) => {
        setSelectedCountry(country);
        setSelectedCity(city);
    };

    return (
        <Box sx={mapBoxStyle}>
            <Stack direction={'row'} spacing={1} sx={mapBoxContentStyle}>
                <MapOptions onResetClick={handleResetMap} onSubmitClick={handleOptionsSubmit} />
            </Stack>
            <MapGoogle offices={offices} triggerReset={resetMap} />
        </Box>
    );
};

export default Map;
